import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ComboDetails } from 'src/app/models/commission/combo-details.model';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { Kpimaster } from 'src/app/models/commission/kpimaster.model';
import { MobileFeedModel } from 'src/app/models/commission/mobile-feed.model';
import { CommissionService } from 'src/app/service/commission.service';
import { GlobalService } from 'src/app/service/global.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-add-mobilefeed',
  templateUrl: './add-mobilefeed.component.html',
  styleUrls: ['./add-mobilefeed.component.css']
})
export class AddMobilefeedComponent implements OnInit {
  public mobileFeedModel = new MobileFeedModel();
  public comboDtl = new ComboDetails();
  public oolDetails: KomFeed[] = [];
  public header: string = 'Add Mobile Feed';
  public products: ComboDetails[] = [];
  public productInfo: ComboDetails[] = [];
  public IsmodelShow: boolean = false;
  public controlStr = new FormControl();

  public actions: any;
  public actionButtons: any;
  public buttons: Buttons[] = [];
  public filteredCommStrValues: Observable<ComboDetails[]> | undefined;
  public field: string;
  public ordersTableColumns: TableColumn[];
  public columnsData: any;
  public isStatus: string = "";
  public resHeadder: string = 'Mobile Feed Results';
  public multicombo: ComboDetails[] = [];
  public comboDtlAdd = new ComboDetails();
  public check: boolean = true;

  public existingOolCurrProducts: ComboDetails[] = [];
  public existingOolPrevProducts: ComboDetails[] = [];
  public existingPremCurrProducts: ComboDetails[] = [];
  public existingPremPrevProducts: ComboDetails[] = [];

  public translateMasterdata: MobileFeedModel[] = [];
  public mobileFeedDeviceTypeData: MobileFeedModel[] = [];
  public mobileFeedPortFlagData: MobileFeedModel[] = [];
  public mobileFeedRecTypeData: MobileFeedModel[] = [];

  constructor(private globalService: GlobalService, private komFeedService: KomFeedService, private commissionService: CommissionService,
    private notificationService: NotificationService, private router: Router, private httpService: HttpClient) { }

  ngOnInit(): void {
    this.getTranslateData();
  }

  getTranslateData() {
    this.komFeedService.getAdminConfigData()
      .subscribe((data: any) => {
        this.translateMasterdata = data;
        console.log(this.translateMasterdata);
        this.getMobileFeedDeviceType();
        this.getMobileFeedPortFlag();
        this.getMobileFeedRecType();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getMobileFeedDeviceType() {
    const filterValue = this.globalService._normalizeValue('Mobile Feed Device Type');
    this.mobileFeedDeviceTypeData = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.field_name).startsWith(filterValue));
    this.mobileFeedDeviceTypeData = this.mobileFeedDeviceTypeData.sort((a, b) => (a.field_value < b.field_value) ? -1 : 1);
    console.log(this.mobileFeedDeviceTypeData);
  }

  getMobileFeedPortFlag() {
    const filterValue = this.globalService._normalizeValue('Mobile Feed Port Flag');
    this.mobileFeedPortFlagData = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.field_name).startsWith(filterValue));
    this.mobileFeedPortFlagData = this.mobileFeedPortFlagData.sort((a, b) => (a.field_value < b.field_value) ? -1 : 1);
  }

  getMobileFeedRecType() {
    const filterValue = this.globalService._normalizeValue('Mobile Feed Rec Type');
    this.mobileFeedRecTypeData = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.field_name).startsWith(filterValue));
    this.mobileFeedRecTypeData = this.mobileFeedRecTypeData.sort((a, b) => (a.field_value < b.field_value) ? -1 : 1);
  }

  public addMobileFeed() {
    console.log("add Called: " + JSON.stringify(this.mobileFeedModel));

    if (!this.mobileFeedModel.transaction_type_name) {
      this.notificationService.sendNotification(NotificationType.WARNING, "Please enter Transaction Type Name");
    } else if (!this.mobileFeedModel.trans_type) {
      this.notificationService.sendNotification(NotificationType.WARNING, "Please enter Transaction Type");
    } else if (!this.mobileFeedModel.account_number) {
      this.notificationService.sendNotification(NotificationType.WARNING, "Please enter Account Number");
    } else if (!this.mobileFeedModel.transaction_complete_date) {
      this.notificationService.sendNotification(NotificationType.WARNING, "Please enter Transaction Complete Date");
    } else if (!this.mobileFeedModel.account_start_date) {
      this.notificationService.sendNotification(NotificationType.WARNING, "Please enter Account Start Date");
    } else {
      this.mobileFeedModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.komFeedService.addMobileFeed(this.mobileFeedModel).subscribe(
        (response: MobileFeedModel) => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, "Submitted Successfully");
        },
        (error: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, error.error.message);
        }
      )
    }
  }

  public back() {
    this.router.navigate(['/adjustments-feed']);
  }

  redirect() {
    this.router.navigate(['/adjustments-feed']);
  }
}


